import { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';

import api from 'services/api';

import { CircularProgress } from '@material-ui/core';
import toast from 'react-hot-toast';
import { Th, Td } from './styles';
import MaterialItem from '../MaterialItem';
import { DownloadPlanilha } from '../DownloadPlanilha';

interface Material {
  descricao: string;
  diteCodigo: string;
}

interface Item {
  material: Material;
  quantidade: number;
}

export default function PropostaConfiguracaoMaterialExcluido({
  temFatDireto,
  propostaVersao,
}: {
  temFatDireto: boolean;
  propostaVersao: any;
}): JSX.Element {
  const [loadingMateriais, setLoadingMateriais] = useState(false);
  const [materiais, setMateriais] = useState<Item[]>();

  async function retornaPropostaConfiguracaoMateriais(): Promise<void> {
    setLoadingMateriais(true);

    try {
      const response = await api.get(
        `/proposta/versao/materiais-excluidos-material`,
        {
          params: {
            propostaVersao,
            temFatDireto,
          },
        },
      );

      setMateriais(response.data);
      setLoadingMateriais(false);
    } catch (error) {
      setLoadingMateriais(false);
      setMateriais([]);
      toast.error('Erro ao retornar os materiais excluidos.');
    }
  }

  useEffect(() => {
    if (propostaVersao) {
      retornaPropostaConfiguracaoMateriais();
    }
  }, [propostaVersao]);

  function BodyMateriais() {
    const materiaisAgrupados = (materiais || []).reduce((acc, item, index) => {
      const { diteCodigo, descricao } = item.material;
      const { quantidade } = item;

      if (!acc[diteCodigo]) {
        acc[diteCodigo] = { diteCodigo, descricao, quantidade };
      } else {
        acc[diteCodigo].quantidade += quantidade;
      }

      // acc[index] = { diteCodigo, descricao, quantidade };

      return acc;
    }, {} as Record<string, { diteCodigo: string; descricao: string; quantidade: number }>);

    const listaFinal = Object.values(materiaisAgrupados || {});

    if (loadingMateriais) {
      return (
        <tr>
          <h5 className="m-3">
            Carregando... <CircularProgress size={14} className="ml-3" />
          </h5>
        </tr>
      );
    }

    if (!materiais?.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Não há materiais excluídos
          </Td>
        </tr>
      );
    }

    return (
      <>
        {listaFinal.map(material => (
          <MaterialItem
            key={material.diteCodigo}
            diteCodigo={material.diteCodigo}
            quantidade={material.quantidade}
            materialDesc={material.descricao}
          />
        ))}
      </>
    );
  }

  return (
    <div className="mx-auto">
      <Card>
        <CardBody className="p-1">
          <CardTitle className="text-right mb-2 mt-2">
            <div>
              <DownloadPlanilha
                data={materiais ?? []}
                isLoadingMateriais={loadingMateriais}
              />
            </div>
          </CardTitle>
          <Table bordered responsive>
            <thead>
              <tr>
                <Th>Código</Th>
                <Th>Material</Th>
                <Th>quantidade</Th>
              </tr>
            </thead>
            <tbody>
              <BodyMateriais />
            </tbody>
          </Table>
          <br />
        </CardBody>
      </Card>
    </div>
  );
}
